// const BASE_URL = import.meta.env.VITE_API_BASE_URL;
const BASE_URL = "https://connect.noju.io/api/";

const actions = {
  initSubscription: () => ({
    method: 'post',
    url: 'dcb/inaugurate'
  }),
  verifyOTP: () => ({
    method: 'post',
    url: 'dcb/confirm'
  }),
  saveTraffic: () => ({
    method: 'post',
    url: 'traffic/record'
  }),
  listenSubscription: () => ({
    method: 'post',
    url: 'dcb/sync'
  })
};

/**
 * Make an API call
 * @param {Object} data - Request data
 * @param {string} type - Action type
 * @returns {Promise<Object>} - Response data
 */
export const callAPI = (data, type) => {
  const headers = new Headers();
  const dt = actions[type]();

  if (!data.web_click_id && typeof window !== 'undefined') {
    data.web_click_id = localStorage.getItem('nj_clickId');
  }

  if (!data.config_id && typeof window !== 'undefined') {
    data.config_id = localStorage.getItem('nj_configId');
  }

  headers.append('Content-Type', 'application/json');
  const body = JSON.stringify(data);

  const requestOptions = {
    method: dt.method,
    headers,
    redirect: 'follow'
  };

  if (body && dt.method !== 'get') {
    requestOptions.body = body;
  }

  let url = BASE_URL + dt.url;
  if (dt.method === 'get' && data) {
    const query = Object.keys(data)
      .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(data[k]))
      .join('&');
    url += '?' + query;
  }

  return fetch(url, requestOptions)
    .then(resp => {
        return resp.json().then(data => {
          if (!resp.ok) {
              const error = new Error('API request failed');
              error.data = data;
              throw error;
          }
          return data;
      });
    })
    .catch(error => {
      console.error('API call failed:', error);
      throw error;
    });
};
